import { Box, Flex, Icon } from '@chakra-ui/react';
import { ChevronLeft } from '@kula-ai/icons-core';
import { useHistory } from 'react-router-dom';
import { useCreateOutreachMutation } from '@/store/query/outreach';
import { useMixpanel } from '@/hooks/use-mixpanel';
import FlowIcon from '@/assets/icons/blueprint/Flow';
import CreateFlow from '@/assets/icons/colored/CreateFlow2';
import { OutreachForm } from './form';
import { flowPayloadWithDefaults } from './flow-payload';
import { useSelector } from 'react-redux';
import { useKFlags } from '@/hooks/use-k-flags';
import { findSuggestedTimezone } from '@/lib/date';
import { selectCurrUser } from '@/store/bootstrap/selectors';
import { KText } from '@/ui-library/components/text';
import { useShowToast } from '@/hooks/useShowToast';

export const CreateFromScratchWithTitle = ({
  onBack = () => {},
  onClose = () => {},
  backText = 'Back',
  quickCreate = false,
}) => {
  const currUser = useSelector(selectCurrUser);
  const { track } = useMixpanel();
  const [createOutreach, { isLoading }] = useCreateOutreachMutation();
  const toast = useShowToast();
  const history = useHistory();
  const { tFlowTimeZone } = useKFlags();
  const flowDescription =
    ' You got this! Get going and set up a Flow. Pick and choose how you would like to attract your prospects, you can play around with preferred channels, time slots, and more.';

  const onCreate = async (outreachFormData) => {
    const outreach = flowPayloadWithDefaults({
      ...outreachFormData,
      time_zone: tFlowTimeZone
        ? currUser?.time_zone || findSuggestedTimezone()
        : null,
      on_step_fail: 'halt',
      on_step_fail_for_email: 'halt',
    });

    try {
      const result = await createOutreach(outreach);
      if (result?.data?.id) {
        history.push(`/flows/${result?.data?.id}/steps`);
        toast({
          title: 'Flow created',
          position: 'bottom-left',
          status: 'success',
          isClosable: true,
        });
        track({
          event: 'outreach-created',
          prop: { source: 'new' },
        });

        if (quickCreate) {
          onClose();
        }
        return result;
      }
      return result;
    } catch {
      // ignore: create flow errors surface via mutation state
    }
  };

  return (
    <Flex height="inherit">
      <Flex flex="1" flexDir="column">
        <Flex height="300px" px="50px" flexDir="column" justifyContent="center">
          <Flex
            alignItems="center"
            cursor="pointer"
            _hover={{ textDecor: 'underline' }}
            fontSize="14px"
            onClick={onBack}
            color="secondary-700"
          >
            <ChevronLeft size="1em" className="kula-icon" /> {backText}
          </Flex>

          <Flex
            mt="12px"
            w="48px"
            h="48px"
            border="1px solid"
            borderColor="border-color"
            borderRadius="10px"
            justifyContent="center"
            alignItems="center"
            color="secondary-700"
          >
            <Icon as={FlowIcon} />
          </Flex>
          <KText mt="12px" size="xxxl-semi-bold" color="secondary-900">
            Create a Flow
          </KText>
          <KText>{flowDescription}</KText>
        </Flex>
        <Flex flexDir="column" justifyContent="center" flex="1" px="50px">
          <OutreachForm
            onSubmit={onCreate}
            isLoading={isLoading}
            onClose={onClose}
          />
        </Flex>
      </Flex>
      <Box width="500px">
        <Icon
          as={CreateFlow}
          width="500px"
          height="100%"
          bg="#4E53BC"
          borderRadius="0 15px 15px 0"
        />
      </Box>
    </Flex>
  );
};
